// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file user.proto (package crossme, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user.proto.
 */
export const file_user: GenFile = /*@__PURE__*/
  fileDesc("Cgp1c2VyLnByb3RvEgdjcm9zc21lIngKBFVzZXISCgoCaWQYASABKAkSDQoFZW1haWwYAiABKAkSFAoMZGlzcGxheV9uYW1lGAMgASgJEhIKCmF2YXRhcl91cmwYBCABKAkSKwoHY3JlYXRlZBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiawoISWRlbnRpdHkSEAoIcHJvdmlkZXIYASABKAkSDwoHc3ViamVjdBgCIAEoCRIPCgd1c2VyX2lkGAMgASgJEisKB2NyZWF0ZWQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQhRaEmNyb3NzbWUuYXBwL3NyYy9wYmIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message crossme.User
 */
export type User = Message<"crossme.User"> & {
  /**
   * Our own id (repo.NewId()), not any provider's. Providers' ids live
   * on the Identity that points at this user.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 5;
   */
  created?: Timestamp | undefined;
};

/**
 * Describes the message crossme.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_user, 0);

/**
 * One external login bound to a User. A separate message (rather than
 * fields on User) so a user can gain additional providers later.
 *
 * @generated from message crossme.Identity
 */
export type Identity = Message<"crossme.Identity"> & {
  /**
   * e.g. "google"
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * The provider's stable id for this user (OIDC `sub`). Never an
   * email: providers recycle those.
   *
   * @generated from field: string subject = 2;
   */
  subject: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 4;
   */
  created?: Timestamp | undefined;
};

/**
 * Describes the message crossme.Identity.
 * Use `create(IdentitySchema)` to create a new message.
 */
export const IdentitySchema: GenMessage<Identity> = /*@__PURE__*/
  messageDesc(file_user, 1);

